import type { IntlShape } from 'react-intl';

import { CombinedError } from '@urql/core';

import { exists } from './filters';
import { slugify } from './strings';

export interface IConvertedError {
    code: string | null;
}

export function convertCombinedError(error?: CombinedError): IConvertedError[] {
    if (!error) {
        return [];
    }

    return error.graphQLErrors.map((errorItem) => {
        const extension = errorItem.extensions as { code: string } | undefined;

        return {
            code: extension?.code,
        } as IConvertedError;
    });
}

export function getErrorMessage(
    intl: IntlShape,
    prefix: string,
    error: CombinedError | unknown,
): string {
    const genericErrorTranslation = intl.formatMessage({
        id: 'error.generic-error.error',
        defaultMessage: 'Generic error has occurred',
    });

    if (!error) {
        return genericErrorTranslation;
    }

    if (error instanceof CombinedError) {
        const errorCodes = convertCombinedError(error);

        const errorCodesFiltered =
            errorCodes?.filter((item) => {
                return exists(item) && item.code;
            }) ?? [];

        if (!errorCodesFiltered || errorCodesFiltered.length === 0) {
            return genericErrorTranslation;
        }

        return intl.formatMessage({
            id: `${prefix}.${slugify(
                errorCodesFiltered[0]?.code ? errorCodesFiltered[0].code : '',
            )}.error`,
            defaultMessage: intl.formatMessage({
                id: `${prefix}.generic.error`,
                defaultMessage: `Missing translation key: ${prefix}.${slugify(
                    errorCodesFiltered[0]?.code ? errorCodesFiltered[0].code : '',
                )}.error`,
            }),
        });
    }

    return genericErrorTranslation;
}
